"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _componentLayerManager = require("@doordash/component-layer-manager");

var _styles = require("../styles");

var _constants = require("../constants");

var _ToastsContainer = _interopRequireDefault(require("./ToastsContainer"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ViewportToasts = function ViewportToasts(_ref) {
  var toastsToDisplay = _ref.toastsToDisplay,
      toastsToRender = _ref.toastsToRender,
      setToastsToRender = _ref.setToastsToRender,
      position = _ref.position;
  return /*#__PURE__*/_react["default"].createElement(_styles.ViewportToastsContainer, {
    position: position
  }, Object.keys(toastsToRender).length ? /*#__PURE__*/_react["default"].createElement(_ToastsContainer["default"], {
    toastsToDisplay: toastsToDisplay,
    position: position,
    toastsToRender: toastsToRender,
    setToastsToRender: setToastsToRender
  }) : undefined);
};

ViewportToasts.propTypes = {
  toastsToDisplay: _propTypes["default"].objectOf(_propTypes["default"].shape(_constants.TOAST_CONTENT_PROPTYPES)),
  toastsToRender: _propTypes["default"].objectOf(_propTypes["default"].shape(_constants.TOAST_CONTENT_PROPTYPES)),
  setToastsToRender: _propTypes["default"].func,
  position: _propTypes["default"].oneOf(Object.values(_constants.POSITIONS))
};
var ViewportConstrainedToasts = (0, _componentLayerManager.renderOnLayer)(_componentLayerManager.Layers.Viewport, ViewportToasts, {
  AnimationType: _componentLayerManager.AnimationTypes.Custom
});
var _default = ViewportConstrainedToasts;
exports["default"] = _default;